import MapBanner from '../assets/ODA_blue_background.svg';
import ODALogoIcon from '../assets/logo_petal.svg'
import BookCover from '../assets/book_cover.svg'
import HeroBanner from '../assets/heroBanner.svg'
import SocialPhone from '../assets/phone.svg'
import SocialYoutube from '../assets/youtube.svg'
import SocialInstagram from '../assets/instagram.svg'
import SocialEmail from '../assets/email.svg'
import SocialLocation from '../assets/location.svg'
import SocialFacebook from '../assets/facebook.svg'
import ODALogo from'../assets/logos/oda_logo.svg'

import tarjetaVerde1 from '../assets/Tarjeta-Verde_know-your-rights-in-mexico.jpg'
import tarjetaVerdeEsp from '../assets/Tarjeta-Verde_conoce-tus-derechos-en-mexico.jpg'

function Home() {
    return (<>
        <div className="App">
            <div className="bannerWrapper">
                <a href="https://www.paypal.com/donate/?hosted_button_id=GSVZ4R47THR82" aria-label="Paypal: Donate to Otros Dreams en Acción (ODA)" target="_blank" rel="noreferrer">
                    <div className="main_first_banner_logo">
                        <img className="image" src={ODALogoIcon} alt="Otros Dreams en Acción icon dandelion" height="50" />
                        <p className="donationText">La lucha sigue, Donate!</p>
                    </div>
                </a>
                <a className="bannerAnniversary" href="http://lxsotrxsdreamers.odamexico.org/" aria-label="Go to Lxs Otrxs Dreamers Book Website" target="_blank" rel="noreferrer">
                    <div className="anniversaryBanner">
                        <img className="main_first_banner_logo_img" src={MapBanner} alt="map blue background" height="160" />
                        <p className="anniversaryText">Lxs Otrxs Dreamers <br /> 10th Anniversary</p>
                        <img className="bookcoverImage" src={BookCover} alt="Otros Dreams en Acción Lxs Otrxs Dreamers book" height="98" />
                    </div>
                </a>
            </div>
            <div className="contentWrapper">
                <img className="main_first_picture" src={HeroBanner} alt="otros dreams en accion pocha house" />
                <div className="main_first_bottom_banner">
                    <h1>ODA’s llamita es que nuestra community aquí y allá sepa que no son lxs únicos, que no están solxs</h1>
                </div>
            </div>

            <section className="section about-more">
                <div className="container">
                    <div className="about-more-contant-wrap">
                        <div className="about-more-left-wrap home-banner">
                            <div className="about-more-image-wrap home-banner">
                            <a className="home-banner-print-text" href="https://drive.google.com/file/d/1a3_HbHXKw8USYQ4prryr7y-x38hg_M5l/view" aria-label="Imprimir PDF Tarjeta Verde conoce tus derechos en México" target="_blank" rel="noreferrer">
                                <img src={tarjetaVerde1} loading="lazy" alt="Otros Dreams en Acción (ODA) Campaign Tarjeta Verde: Know your rights in Mexico" className="about-more-image" />
                                Tarjeta Verde: Know your rights in Mexico
                            </a>
                            </div>
                        </div>
                    <div className="about-more-middle-wrap">
                        <div className="about-more-contant">
                        <div className="section-mini-title-wrap">
                                <div className="section-mini-title-flex">
                                    <div className="section-mini-title home-banner">Campaign Tarjeta Verde: Know your rights in Mexico for Returnees and Deportees</div>
                                </div>
                            </div>

                            <h3 className="about-more-details home-banner">
                                In collaboration with Comunidad en Retorno, Otros Dreams en Acción, and the Coalición de Migrantes Mexicanos, through the example of the <a href="https://www.ilrc.org/red-cards-tarjetas-rojas" className="red-card-home-banner-link">Red Card created by Immigrant Legal Resource Center (ILRC)</a> we have been designing tools for deportees and returnees to...
                            </h3>
                            <div className="button-wrapper">
                                <a href="https://www.odamexico.org/tarjeta-verde" className="primary-button w-inline-block">
                                    <div className="primary-button-text">Know Your Rights in Mexico</div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="about-more-right-wrap">
                        <div className="about-more-image-wrap home-banner">
                        <a className="home-banner-print-text" href="https://drive.google.com/file/d/1a3_HbHXKw8USYQ4prryr7y-x38hg_M5l/view" aria-label="Imprimir PDF Tarjeta Verde conoce tus derechos en México" target="_blank" rel="noreferrer">
                            <img src={tarjetaVerdeEsp}  loading="lazy" alt="Otros Dreams en Acción (ODA) Campaña Tarjeta Verde: Conoce tus derechos en México para deportados y retornados" className="about-more-image"/>
                            Tarjeta Verde: Conoce tus derechos en México
                        </a>
                        </div>
                    </div>
                </div>
                </div>
            </section>
            <div className="contactUsWrapper">
                <div className="contactInfo">
                    <h2 className="contactUsTitle">Contactanos</h2>
                    <a className="contactItem" aria-label="Chat on WhatsApp" href="https://wa.me/525568751027" target="_blank" rel="noreferrer">
                        <img className="contactIcon" src={SocialPhone} alt="whatsapp phone icon" width="40" />
                        <p className="contactText">+52 55 6875 1027</p>
                    </a>
                    <div className="contactItem" aria-label=" Email">
                        <img className="contactIcon" src={SocialEmail} alt="Email icon" width="40" />
                        <p className="contactText">info@odamexico.org</p>
                    </div>
                    <a className="contactItem" href="https://maps.app.goo.gl/buKd5hAshrr34aR39" aria-label="Open Google Maps directions ODA Pocha House" target="_blank" rel="noreferrer">
                        <img className="contactIcon" src={SocialLocation} alt="address icon" width="40" />
                        <p className="contactText">Pocha House - Tonalá 194 Int-C, Roma Nte., CDMX, Mexico</p>
                    </a>
                    <div className="contactSocialMedia">
                        <a className="contactItem" aria-label="Visit ODA's Instagram" href="https://www.instagram.com/otros_dreams_en_accion/" target="_blank" rel="noreferrer">
                            <img className="contactIcon" src={SocialInstagram} alt="Instagram icon" height="45" />
                        </a>
                        <a className="contactItem" aria-label="ODA Facebook" href="https://www.facebook.com/OtrosDreams" target="_blank" rel="noreferrer">
                            <img className="contactIcon" src={SocialFacebook} alt="Facebook icon" height="45" />
                        </a>
                        <a className="contactItem" aria-label="ODA Youtube" href="https://www.youtube.com/@odaotrosdreamsenaccion6686" target="_blank" rel="noreferrer">
                            <img className="contactIcon" src={SocialYoutube} alt="Youtube icon" height="45" />
                        </a>
                    </div>
                </div>
            <div className="address">
                <iframe
                    className="mapFrame"
                    title='Address Pocha House - Tonalá 194 Int-C, Roma Nte., CDMX, Mexico'
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.0060474405946!2d-99.16345242381405!3d19.412144681862827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff2f6fcddfb7%3A0x9a8716a15fd7ae2e!2sODA%3A%20Pocha%20House!5e0!3m2!1sen!2smx!4v1726523137603!5m2!1sen!2smx"
                    loading="lazy">
                </iframe>
            </div>
        </div>
        </div><div className="footer">
            <img className="image" src={ODALogo} alt="Otros Dreams en Acción logo" height="95" />
        </div>
    </>);
}

export default Home;
